module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct-top",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1: You Were an Accident")])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_vm._v("1922–1940")]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE WEDDING OF")]), _vm._v(" Kurt Vonnegut’s parents, Edith Sophia Lieber and Kurt Vonnegut Sr. on November 22, 1913, in Indianapolis, Indiana, was spectacular.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Edith’s father, Albert, owner of a giant brewery who reveled in his reputation as one of the richest men in the city, threw a gargantuan reception at the Claypool Hotel at the northwest corner of Washington and Illinois streets, reputed to be the finest hotel in the Midwest. There were six hundred guests, and those not chauffeured in automobiles arrived in horse-drawn carriages with jingling brass harnesses—an entire generation of rich Edwardians, silk-hatted or covered demurely by parasols, many of whom had been raised in Indianapolis’s mansions on Meridian Street."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn1",
      "id": "ch1-fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Albert Lieber knew what his guests expected and he did not disappoint. There was a sixty-foot bar, choice meats, champagne, and dancing to an orchestra in the ballroom lasting until six in the morning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And to the satisfaction of some guests, there was plenty of gossip to go around, too. The bride had graduated from Miss Shipley’s finishing school in Bryn Mawr outside Philadelphia in time to come out for the 1908 season in London. Her first serious suitor, Kenneth Doulton, whose family owned the world famous Royal Doulton Porcelain Works, had proposed. He said his father would buy them a house in Mayfair, hinting that they could live very well if her father would settle a good-sized dowry on her. But she suspected he was an upper-class idler who wanted a sinecure and not the responsibility of inheriting a giant brewery in Indianapolis. She broke off the engagement.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then she had crossed the English Channel to live in her grandfather Peter Lieber’s castle in Düsseldorf. There she caught the eyes of two German cavalry officers who competed for her affections. She had become engaged to the higher-ranking one, a captain—a Prussian, Otto Voigt, whose saber, boots, and brass buttons looked dashing. Unfortunately, like the English gentleman who had preceded him, he had no interest in the Lieber family brewery either. She ended that engagement too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So she had retreated home to her father’s estate, Vellamada, outside Indianapolis, where he built for her a cottage on a bluff overlooking the White River and furnished it according to her tastes, with a fireplace and a grand piano in the living room. Many days she spent hours strolling around the grounds alone."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn2",
      "id": "ch1-fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No one recalled exactly how the groom, Kurt Vonnegut Sr., came on the scene romantically, but he and Edith, four years his junior, had known each other since childhood. Both families belonged to Indianapolis’s coterie of wealthy German Americans who gravitated to Das Deutsche Haus, the city’s German cultural center. Money and the suitability of the young couple were on the minds of both families, naturally.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Kurt Sr., a promising, second-generation Indianapolis architect, already had the imprimatur of older successful men in the city who had invited him to join the exclusive University Club. He was a graduate of Massachusetts Institute of Technology (MIT) with a degree in architecture and had completed postgraduate work at Hannover Polytechnic in Germany, just like his father, Bernard. Two years after his father’s death in 1908, Kurt Sr. had returned from abroad and joined his father’s architectural firm, Vonnegut & Bohn, as a partner. He was short, blue-eyed, and fair with blond curly hair and long, thin fingers. His bride was a lovely woman with auburn hair, a fair complexion, and blue-green eyes. They had made a handsome couple at the altar of the First Unitarian Church, according to family members, the only ones invited to attend the actual ceremony. Apparently, the Unitarian Church had been chosen because the Vonneguts had been freethinkers for generations and the Liebers were Protestants—it was common ground.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The reception at the Claypool Hotel was the finishing touch to the combining of two elite families. Under the weight of millionaire Albert Lieber’s inexhaustible largesse in the way of food and drink, all the propriety of Indianapolis’s upper crust crumbled. “Never before or since have so many otherwise respectable and thoroughly conservative citizens of the dull community passed out in so short a time,” said a family historian."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn3",
      "id": "ch1-fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Dozens of guests were still recuperating in reserved rooms two days later.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Soon after their marriage, Kurt and his bride drove to the Indianapolis Speedway in a brand-new Oldsmobile and sped around and around the track in a delirium of happiness."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn4",
      "id": "ch1-fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" It was the beginning of their lives together. Conveniently, everything in Edith’s trousseau was already monogrammed "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("L-V")]), _vm._v(" from her engagement to the Prussian captain, Otto Voigt."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn5",
      "id": "ch1-fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE WEDDING")]), _vm._v(" reception was fitting for wealthy young socialites starting out. While Kurt Sr. had been a bachelor, he had taught artistic lettering at the John Herron Art Institute and become friends with amateur artists. Edith had been a member of the Indianapolis Propylaeum, a selective literary and social club for women.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But after their marriage the Vonneguts were catapulted into realms generally open only to leading couples. The biggest coup was an invitation to join the Portfolio Club founded by the Hoosier Group artist Theodore Clement Steele and his late wife, Mary Elizabeth. The membership roster consisted exclusively of Midwestern artists, writers, or painters who supported the Arts and Crafts movement. There were monthly dinner discussions, and the group, said one onlooker, “considered itself to be the custodian of the aesthetic conscience of the community.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn6",
      "id": "ch1-fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" As the newest female member attending the club dinner in January 1917, Edith was chivalrously (and humorously) awarded the tail of the roast pig."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn7",
      "id": "ch1-fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Vonneguts reciprocated by entertaining in their home at 1334 Central Avenue, located in one of the better neighborhoods. They sometimes had the director of the Indianapolis Symphony Orchestra to supper, or writers and painters, or architects who were colleagues of Kurt Sr.’s."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn8",
      "id": "ch1-fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Edith’s dinner parties were memorable just for their settings, three generations of inherited Lieber treasure on display: china, silver, linen, and crystal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With such a heavy social calendar, the only way to keep the house in order was with a live-in servant, especially after the Vonnegut children began coming along."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn9",
      "id": "ch1-fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ERNARD")]), _vm._v(" V"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ONNEGUT,")]), _vm._v(" named for his paternal grandfather, was born August 29, 1914. He was a serious-looking little boy, even in informal photographs. The earliest anecdote about him predicted a fascination with science and technology. One afternoon when he was a toddler, his parents left him in the care of a babysitter. They didn’t return until late that evening, long after he was asleep. The next morning, they noticed he was “all excited and making unusual noises.” The mystery was cleared up a few days later when a family friend mentioned seeing Bernard at Union Station in the arms of the babysitter. She had taken him down to the station—a half-hour walk—to meet her boyfriend on the platform. His “unusual noises” were the sounds of locomotives."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn10",
      "id": "ch1-fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Many small children love trains, of course, but as soon as he was old enough, Bernard set up a laboratory in the basement to find out more about steam, power, and electricity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Vonneguts’ only daughter came next, Alice, born November 18, 1917. In babyhood, she developed a serious case of pneumonia and nearly died from a high fever."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn11",
      "id": "ch1-fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Kurt Jr. later believed it addled her a little."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn12",
      "id": "ch1-fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" She refused to tolerate anything that might upset her. She shunned books and preferred make-believe instead. The sight of a truck on the highway carrying chickens on their way to market sent her into hysterics, and only her parents’ assurances that those chickens were on their way to a new farm could calm her down."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn13",
      "id": "ch1-fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Perhaps having been lavished with her parents’ concern when she was ill, she discovered a dependable way to keep their attention on her. And since Bernard was laying claim to being the brainy one, why shouldn’t she be the one with overwrought feelings? Every child must carve out a niche for him- or herself in a family.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE")]), _vm._v(" V"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ONNEGUTS’")]), _vm._v(" youngest child, Kurt Jr. (“a beautiful boy with curly hair—an exceptionally beautiful child, really,” said his father’s sister, Aunt Irma), was born in Indianapolis on November 11, 1922, or Armistice Day as it was called before World War II."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn14",
      "id": "ch1-fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" As an adult, he was quite proud of being born on a day associated with peace."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn15",
      "id": "ch1-fn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His parents were living by then in a new, larger house at 4401 North Illinois Street, located in a neighborhood of large brick and limestone residences on the city’s north side near Butler University. It had been built with Edith’s money, even though Prohibition in 1921 had caused a catastrophic downturn in her father’s brewery fortune. But there was a building boom going on after World War I, and Kurt Sr. anticipated regular commissions to provide a comfortable financial bumper for his family.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Set back deep on a half-acre wooded lot, the house, which is still standing, is turned sideways, giving it a slightly unwelcoming look. The long flank of the three-story, six-bedroom house faces the street; the front door is toward the narrow side yard. The style is Arts and Crafts, and framed in a leaded, stained-glass window on the front door are the letters "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("K, E,")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("V")]), _vm._v(" for Kurt and Edith Vonnegut. Underneath the window is an unusual door knocker, a woman with a Roman face, her head crowned with leaves, and two festoons of palm fronds beneath her ears, looping down to where they meet at a brooch, creating the handhold for rapping on the strike plate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Throughout his life, Kurt Jr. insisted his father designed the house. Actually, it was done by the Indianapolis-born architect William Osler, some of whose other residences are still standing in Indianapolis and are similar in style to the Vonneguts’. There was very little input in the house from Kurt’s father, and the fact that he engaged someone else to design his home is revealing about his talent or interests, for that matter."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn16",
      "id": "ch1-fn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In his colleagues’ estimation, Kurt Sr. was an architect with modest abilities."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn17",
      "id": "ch1-fn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" His bread-and-butter income came from commercial projects such as Hook’s Drugstores and Indiana Bell Telephone buildings. As his clients’ buildings grew higher, wider, multipurposed, and blander, he relied on technical knowledge to bring in the fees, not style or character.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His father, Bernard, on the other hand, had enhanced the built environment of Indianapolis with dozens of distinctive structures, including the John Herron Art Institute, the Hotel Severin, and the enormous Das Deutsche Haus designed in German Renaissance Revival style with a beer garden and theater."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn18",
      "id": "ch1-fn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Bernard’s design for the Pembroke Arcade in downtown Indianapolis, inspired by the architecture of the 1893 World’s Columbian Exposition in Chicago, was a forerunner of the modern shopping mall. An Indianapolis historian and contemporary said of Bernard, “All of his work was carefully detailed and bore evidence of his scholarly tastes as an architect as well as of his superior technical ability.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn19",
      "id": "ch1-fn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But no major projects from the hand of Kurt Sr. still exist, no “monuments to his genius,” as his father’s work was once described."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn20",
      "id": "ch1-fn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The apprentice lacked confidence in his artistic skills to exceed the master. He enjoyed experimenting in a dilettantish way with calligraphy, painting, and pottery, especially as he got older. And as an architect, he had a trained sense of style. Yet his youngest son, Kurt Jr., was never sure his “father wanted to be an architect, he was just the oldest son and he was told to become an architect.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn21",
      "id": "ch1-fn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" He never heard his father mention anything about grandfather Bernard. He suspected it was because his father knew he was mediocre by comparison."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn22",
      "id": "ch1-fn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nevertheless, income from Kurt Sr.’s commissions and his wife’s investments provided expensive garnishes to their lives. When they were flush with cash, they traveled and entertained. Typical was a trip aboard a ship from New York to Hamburg, Germany, in July 1924, to attend the wedding of Kurt Sr.’s sister, Irma, to a German, Kurt Lindener, who owned plantations in Honduras. Alice was seven years old by then and Bernard ten. Nineteen-month-old Kurt Jr. was left behind in the care of his paternal uncle Alex and his wife, Raye, who were childless. (Much later, when he was old enough to understand, he decided his mother had done it because he was an inconvenience.)"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn23",
      "id": "ch1-fn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" The family also took annual summer vacations to the seaside town of Chatham on the southeastern tip of Cape Cod, where the children could play tag with the waves."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn24",
      "id": "ch1-fn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" If the Vonneguts needed money, they sold securities or borrowed it."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn25",
      "id": "ch1-fn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A private education for the children went without saying. As soon as Kurt Jr. was of school age, his parents enrolled him in the Orchard School, a private progressive school with grades kindergarten through eighth on West Forty-second Street in Indianapolis, recently redesigned by Kurt Sr. and a colleague. Bernard had graduated from there and continued on to the Park School, a small private high school for boys. Alice was already an Orchard student in the middle grades when Kurt Jr. was enrolled as a kindergarten student in the fall of 1928.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Orchard School operated on the educational theorist John Dewey’s belief that the students should be a little community of doers. There were gardens, pottery making, music lessons, pretend bank accounts, shop class, pageants, outdoor biology, art, and folk dancing. Each child had a responsibility. An important influence on Vonnegut was a teacher who eventually became headmaster, Hillis Howie. Later in life, Vonnegut said, “The value system under which I try to operate relative to animals and plants and the earth and persons with cultures different from mine is one I learned from him. There are thousands of us who were lucky enough to come under his influence, and my guess is that we are more at home on this planet, and more respectful of it, than most of our neighbors are.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn26",
      "id": "ch1-fn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This hothouse educational environment encouraged Kurt Jr.’s precociousness. One of his teachers commended him on how well he could read."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn27",
      "id": "ch1-fn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" At home, he secretly pored over an unabridged dictionary from his parents’ large library because he “suspected that there were dirty words hidden in there” and puzzled over illustrations of the “"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("trammel wheel")]), _vm._v(", the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("arbalest")]), _vm._v(", and the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("dugong")]), _vm._v(".”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn28",
      "id": "ch1-fn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Later, when he was old enough, he dipped into his parents’ complete works of Robert Louis Stevenson, Bernard Shaw, Arthur Conan Doyle, and a beautiful edition of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Lysistrata")]), _vm._v(", which he claimed to have read when he was eleven."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn29",
      "id": "ch1-fn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Getting his teachers’ attention was easy, he found, but his parents were another matter. His father, dignified and reserved, was said to take after his own father."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn30",
      "id": "ch1-fn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Toward his children, Kurt Sr. acted coolly. His conversations with his younger son tended to be “arch and distant.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn31",
      "id": "ch1-fn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Nor did he seem interested in teaching him how to become proficient at things, again according to Kurt Jr., who remained quite resentful about this; he never forgot it. “Nobody taught me anything—how to skate, or even ride a bike.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn32",
      "id": "ch1-fn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His father could be witty, but in such a wry way that it was hard to tell whether he was joking. The sense of humor in the house was Schadenfreude—very Germanic—taking pleasure in the misfortunes of others. Listening one afternoon to act 4 of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Aida")]), _vm._v(", Kurt Sr. remarked in a bemused voice that the lovers sealed in a temple would last a lot longer if they didn’t sing so much."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn33",
      "id": "ch1-fn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The children’s taste for Schadenfreude too expressed itself in a love of pratfalls. Alice, for instance, hearing a series of thuds, thought her younger brother had fallen down the stairs, and rushed to make fun of him. It was the gas meter man who had tumbled into the basement. She laughed even harder. Another time she caught sight of a woman falling out a bus door horizontally like an ironing board and doubled over with giggles."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn34",
      "id": "ch1-fn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Likewise, Kurt Jr., for the rest of his life, had an odd (and sometimes disconcerting) habit of laughing suddenly in the middle of describing something unpleasant. It was hard to tell whether he was upset or tickled by absurdity. One of his favorite anecdotes in adulthood was about a fraternity brother who heard the news of Pearl Harbor while showering. When Vonnegut got to the punch line—the guy was so shocked he fell in the tub and killed himself!—he would try to suppress a wheezing, half-ashamed snigger."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn35",
      "id": "ch1-fn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Edith Vonnegut behaved like a guest in her children’s lives. To her way of thinking, parenting came under the general heading of household tasks, which, as a wealthy woman, she could pay others to do. “Mother,” said Kurt Jr., “did not cook.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn36",
      "id": "ch1-fn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Nor did she sew on buttons, plant flowers outdoors—the yardman did that—or, as her son remembered it, speak to him very much."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn37",
      "id": "ch1-fn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" She did enjoy dressing the children in fine clothes, however, which she selected from the best department store in town, L. S. Ayres (which had also been designed by her father-in-law), and lunching with her lady friends in the walnut-paneled Victorian tearoom. In the Vonneguts’ home movies taken in the 1920s, she waves brightly to let us know she is present, but she never hugs the children to indicate that they are a joy to her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The only sign of family affection—other than horseplay at the beach on Cape Cod, also seen in family films—occurs between Kurt Jr. and Alice, who guides her beaming, wide-eyed little brother past the camera tenderly by the hand. And in another scene, when they are seated beside each other in a toy wagon, he buries his face in her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But a sister who is only five years older is not an adequate substitute for a mother. To find a “humane and wise” person to listen to his chatter, answer his questions, and read to him, he looked elsewhere."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn38",
      "id": "ch1-fn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ORTUNATELY, THERE")]), _vm._v(" was such a person in the household, the Vonneguts’ cook and housekeeper, Ida Young.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mrs. Young was a middle-aged woman when she worked part-time for the Vonneguts. An African American born in Kentucky in 1883, she married her husband, Owen, a warehouse worker, at eighteen; the couple owned a home at 1940 Yandes Street, a good twenty-minute ride by trolley from the Vonneguts. She found employment with white families in 1926 because her husband had passed away and she was on her own. A few years later, one of her children moved in, bringing with him seven of her grandchildren. From then on, her life consisted mainly of work and caring for children. She cooked and cleaned for the Vonneguts five days a week, with Thursdays and Sundays off."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn39",
      "id": "ch1-fn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ida did not have the authority to take the Vonnegut children in hand the way she did her own."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn40",
      "id": "ch1-fn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Mostly, the Vonnegut parents disciplined passively “by showing discontent,” as Kurt Jr. put it."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn41",
      "id": "ch1-fn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" But he was very young, suggestible, and, most important, lonely. “She talked to me more than my mother ever did and spent more time with me than my mother ever did.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn42",
      "id": "ch1-fn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Ida often mentioned him to her grandchildren and was clearly very fond of him."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn43",
      "id": "ch1-fn43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" By responding to his eagerness for adult affection, she won his heart, making it receptive to what she had to say about kindness, honesty, and proper behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was a Methodist, and the Bible was her instruction manual for family life."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn44",
      "id": "ch1-fn44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" She “knew the Bible by heart and found plenty of comfort and wisdom in there,” Kurt Jr. wrote later."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn45",
      "id": "ch1-fn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" The Vonneguts attended services at the Unitarian Church only twice a year, on Christmas Eve and Easter, and the family said grace at meals, but in retrospect he termed it just a “theatrical event.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn46",
      "id": "ch1-fn46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Searching for something to read aloud to Kurt Jr., Ida found in the Vonneguts’ library a popular anthology of stories, poems, verses, and essays called "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("More Heart Throbs")]), _vm._v(", the second volume in a series of books with inspiring passages. Many of the entries were anonymous verses, but there were also rhythmic, easy-to-read pieces by Ralph Waldo Emerson, Christina Rossetti, Emily Dickinson, Robert Louis Stevenson, and James Whitcomb Riley."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn47",
      "id": "ch1-fn47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" The frontispiece shows a woman in a long white dress reading as she walks in the spring. The caption says, “The little cares that fretted me, / I lost them yesterday / Out in the fields with God.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Years later, Vonnegut didn’t recall any religious instruction from Ida, but said, “I’m sure she must have talked about God and I was interested to hear about it.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn48",
      "id": "ch1-fn48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" They pored over the book, and the effect of the experience, amplified by how a caring adult was taking an interest in him, affected him for the rest of his life. “There is an almost intolerable sentimentality in everything I write. British critics complain about it. And Robert Scholes, the American critic, once said that I put bitter coatings on sugar pills. It’s too late to change now. At least I am aware of my origins—in a big, brick dream house designed by my architect father, where nobody was home for long periods of time, except for me and Ida Young.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn49",
      "id": "ch1-fn49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("W"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HILE")]), _vm._v(" K"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("URT")]), _vm._v(" Jr. was still a child in primary school feeling the effects of benign neglect at home, as he remembered it, Bernard, a high school student in the late 1920s, was earning a reputation in science that made his parents proud. His teachers at the prestigious Park School agreed with the assessment of Bernard’s great-uncle Carl Barus, a founder of the American Physical Society, that he was “peculiarly gifted when honoring the scientific method with playful experiments involving ordinary materials close at hand.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn50",
      "id": "ch1-fn50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Even when one of his experiments blew a bolt through the first floor of the Vonneguts’ home, or his telegraph key blanked out every radio station in Indianapolis for three miles around, his parents were dazzled. Kurt Jr. later begrudged him his unassailable status in the family: “He was my parents’ darling, as the firstborn should be, I suppose.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn51",
      "id": "ch1-fn51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To his teachers and parents, Bernard might be a young Edison, but how he lorded it over his brother and sister annoyed them. Kurt Jr. tried to play his older brother’s assistant and helped when asked during experiments. But he began to feel resentful of the supposed superiority of that “hilarious baboon.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn52",
      "id": "ch1-fn52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Science was all that mattered in his worldview. Litmus paper, slide rules, anemometers yielded real values; everything else was just opinion. Sometimes, in sheer childish frustration, Kurt Jr. flailed at his older brother while Bernard held him at arm’s length, chuckling."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn53",
      "id": "ch1-fn53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" “He was a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("boring bully")]), _vm._v(". Never hit me, but he would talk and talk about science until my sister and I were bored shitless.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn54",
      "id": "ch1-fn54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Enviously he watched one day while his father and brother performed what looked like alchemy in the backyard. Wearing thick rubber gloves, they dropped several dimes in a plastic bucket of nitric acid. A few more ingredients in the process and then there, glistening at the bottom of the bucket, lay grains of pure silver. Another experiment involved igniting black iron oxide and powdered aluminum at high temperatures to create molten aluminum oxide. Bernard used blobs of it to spot-weld nails into a spiny shape that could be separated only with a hacksaw. His power was astonishing!"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn55",
      "id": "ch1-fn55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By comparison, Kurt Jr. felt intense self-disgust. He kept a childish diary; even though “nothing ever happened to me … I wrote pages and pages.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn56",
      "id": "ch1-fn56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" No one was encouraging him, showing him experiments. His father was attuned to the intellect rather than emotional pleading. “Bernard was obviously gifted and it’s like having a great chess player suddenly or a musician or whatever. He was something of a prodigy at least in terms of his enthusiasm for science. It was clear he was going to be a scientist from early on and when I tried it I obviously did not have the same gifts he had, so something genetic is going on there.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn57",
      "id": "ch1-fn57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Furthermore, Bernard’s signs of genius gave him leverage in the family beyond the usual pride of place of an eldest child. In his world of facts and results, sensibility was gibberish. Alice demonstrated an ability to capture likenesses quickly in clay sculpture, but Bernard wasn’t impressed. “Art,” he was fond of saying, “is just ornamental.” Visiting a local art museum in the company of his family, he jeered, “Look at those paintings! They just hang there!”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn58",
      "id": "ch1-fn58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" By implication, his father’s vocation—architecture can be seen as extension of art, after all—was just as lowly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By the time he was a teenager, Bernard began to look on his family as part of his laboratory and took a Skinnerian interest in what they did, how they behaved, and why. His curiosity about his parents’ sexual relationship gave rise to an experiment when he was sixteen and Kurt Jr. was seven. Using the heat register in his parents’ bedroom as a conduit, Bernard ran a wire for a microphone under his parents’ bed and connected it to a tape recorder. Soon he had results about sex between adults that he was eager to share with his brother."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn59",
      "id": "ch1-fn59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were riding together in the car when Bernard turned to him and said, “You were an accident.” Kurt Jr. remembered feeling confused and fearful. “I didn’t know what it meant to be an ‘accident,’ but I knew accidents weren’t good.’”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn60",
      "id": "ch1-fn60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("I"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("N")]), _vm._v(" O"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CTOBER")]), _vm._v(" 1929, the Wall Street crash pushed the Vonneguts’ upper-class life toward a financial precipice. They were overextended, house-poor, but in love with the amenities of the good life. Waves of bad economic tides lapped at Kurt Sr.’s profession, eroding his commissions. Desperately, he and Edith leaped at a Ponzi scheme, buying into it with an inheritance left to them by grandmother Nannette Vonnegut, who passed away in December 1929."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn61",
      "id": "ch1-fn61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" Everything was lost. To keep going, they sold their securities and borrowed as much as they could."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn62",
      "id": "ch1-fn62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" It still wasn’t enough. As a result, Edith Vonnegut, one of the richest women in town, slowly became, according to her son Kurt, “half-cracked.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn63",
      "id": "ch1-fn63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Fortunately, in 1930 an unusual project came Kurt Sr.’s way, the income from which kept the family afloat for a while. But more important, how expertly he handled the work involved implied that—as Kurt Jr. later suspected—his father had become an architect by default. His true ability was technological.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In downtown Indianapolis, the Indiana Bell Building housed all the telephone and telegraph equipment for central Indiana. The board of directors needed to add administrative offices at the site, but there was nowhere to build. After entertaining several unsatisfactory proposals about ways to expand, the directors were close to accepting that the eight-story, eleven-thousand-ton structure would have to be demolished.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But then Kurt Sr. proposed an extraordinary plan. The solution was to turn the whole building. This could be accomplished without damage to the building, and business on all floors could continue as usual during the move—no interruption to the tens of thousands of calls routed through the switchboards every day. The gas, light, and heat would stay on too, even the elevators would go up and down as the building advanced fifty-two feet forward off its foundation, then swung through a ninety-degree arc, and finally moved one hundred feet backward on rails. When at last it rested on its new foundation, the Indiana Bell Building would have been relocated, with all the employees inside, from its former address on Meridian Street to New York Street. In the rear would be plenty of room for expansion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The board consented, either because Vonnegut was so persuasive or out of sheer curiosity to see whether such an incredible thing could be done.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Before the move, giant hoses were connected to utilities so that gas, water, and heat would continue as usual. Then underneath the bottom of the building, Vonnegut positioned eighteen jacks weighing one hundred tons apiece. On October 14, the turning around began. Engineers from all over the nation, as well as a few from abroad, came to observe what would happen. On a signal, each worker operating a jack gave the lever six complete up-and-down strokes. The building rose a fraction of an inch. Then the men rested. At the next signal, they gave the levers exactly six strokes and rested. This continued until the building was up a foot. Blocks and temporary jacks were knocked into place, and then the huge jacks repositioned to turn the building incrementally toward a set of rails. The rhythm of eighteen men working in syncopation continued.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Every workday, employees and customers arrived at the building’s entrance via a curved walkway that was constantly being lengthened to keep up with the turning front door. Inside, telephones rang, operators put through calls, and meetings were held, but workers couldn’t help glancing out the windows now and then to see how the view was changing. Site superintendents distributed squashed pennies from the rails to spectators as souvenirs of the historic event, including one for Kurt Jr., who was then eight years old. Finally, in mid-November 1930 the building came to rest on its new foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was the largest building of its time ever moved.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Throughout his life, Kurt Jr. mentioned his father’s historic engineering achievement only in passing. National magazines carried the story, and requests for information about the technical side of the move continued to arrive at Indiana Bell forty-six years after the event."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn64",
      "id": "ch1-fn64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Yet the son of the titan responsible for the deed preferred instead to let it be known that he was from a family of artists: “Here I am making a living in the arts, and it has not been a rebellion. It’s as though I had taken over the family Esso station. My ancestors were all in the arts, so I’m simply making my living in the customary family way.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn65",
      "id": "ch1-fn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" By insisting that the arts, and not technology, coursed through the Vonnegut bloodline, he made it clear that he was the true heir of his family’s dreams, and not his older brother, Bernard.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ESPITE THE")]), _vm._v(" astounding success of the Indiana Bell Building move, the firm of Vonnegut, Bohn & Mueller, as it was then known, was forced to disband. Kurt Sr. set up a home office and accepted jobs, his son Kurt said later, that “would have been soporific to a high school drafting class.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn66",
      "id": "ch1-fn66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The big house on Illinois Street would have to be sold, it was clear, and in 1932 the Vonneguts put it on the market. But year after year there were no takers. A demi-mansion with servants’ quarters was a white elephant in an era of hoboes, the Dust Bowl, and soup kitchens. Gradually, the Vonneguts were going under financially and began selling off ballast that had once anchored them in the upper class: china, jewelry, and artwork. The hired help was let go, including Ida Young, although the Vonneguts continued to give her clothes and items for her family."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn67",
      "id": "ch1-fn67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Edith kept reassuring her youngest child that the Vonneguts would rise to the top again, and he would resume his “proper place in society” when the bad times ended and “would swim with members of other leading families at the Indianapolis Athletic Club, would play tennis and golf with them at the Woodstock Golf and Country Club.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn68",
      "id": "ch1-fn68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" In the meantime, he would have to leave Orchard School and begin the fourth grade at a public school—“a wise use of resources,” he thought bitterly as an adult."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn69",
      "id": "ch1-fn69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Alice would finish at the private Tudor Hall School for Girls and Bernard at the Park School.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For Edith, the humiliation of her precipitous fall in society affected her mental health. Kurt Jr. likened it to withdrawal from a drug. “My mother was addicted to being rich, to servants and unlimited charge accounts, to giving lavish dinner parties, to taking frequent first-class trips to Europe.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn70",
      "id": "ch1-fn70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" With only a modest income, her husband was unable to provide the things that had formerly made her life as pleasant as a garden party.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Furiously, she turned on him, and Kurt Jr., only nine or ten, watched wide-eyed as his mother tore at his father."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn71",
      "id": "ch1-fn71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" “Late at night, and always in the privacy of our own home, and never with guests present, she expressed hatred for Father as corrosive as hydrofluoric acid.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn72",
      "id": "ch1-fn72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Her insults were scattershot but always with the same target: he was a failure as a man. He was unfaithful, she said; his false teeth were cheap and disgusting; he couldn’t make more money because he was afraid to try."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn73",
      "id": "ch1-fn73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her doctor prescribed sodium amytal, a barbiturate with sedative-hypnotic properties, but it twisted her personality."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn74",
      "id": "ch1-fn74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" In the dead of night, she roamed the house, wrapped in a ghostly drug-induced mist, rattling doorknobs and dishes like a poltergeist. The family endeavored to keep her midnight-to-dawn craziness a secret."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn75",
      "id": "ch1-fn75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" Some of her behavior was histrionic—she would fall to the ground rather than have her picture taken—but according to Kurt Jr. “the hatred and contempt she sprayed on my father, as gentle and innocent a man as ever lived, was without limit and pure, untainted by ideas or information.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn76",
      "id": "ch1-fn76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To escape her assaults, Kurt Sr. retreated to an artist’s studio he created on the top floor in the vacated bedroom formerly belonging to a servant. There he turned into, in his son Kurt’s words, a “dreamy artist.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn77",
      "id": "ch1-fn77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" He painted portraits of friends and relatives, and many self-portraits, too. But there was something about his self-portraits that indicated he no longer recognized himself. On canvas after canvas he left sketches of his face unfinished, as if he couldn’t decide on his own likeness or how he wanted to appear."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn78",
      "id": "ch1-fn78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Predictably, his parents’ unhappiness put a strain on Kurt Jr. that surfaced in school. One day in the seventh grade, he was called into the office by the principal. “He asked me what was wrong, because I apparently was flunking everything and he said I might have to repeat the seventh grade and I didn’t know what was wrong. I might have to repeat the seventh grade!”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn79",
      "id": "ch1-fn79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He didn’t flunk middle school, as it turned out. He graduated eighth grade on time in June 1936 with the rest of his class. Part of the ceremony included each graduate receiving a diploma from the principal, then turning to the audience and announcing his or her career plans. When it was Kurt Jr.’s turn, he made an announcement guaranteed to please both his parents in the audience. “I said, I would cure cancer with chemicals while working for the Eli Lilly Company.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn80",
      "id": "ch1-fn80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In other words, he would try to grow up to be just like Bernard.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("W"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HEN SUMMER")]), _vm._v(" came, everything was always better. There was a second home for the Vonneguts where the sunlight put a blush on everyone’s face, and the water for swimming and bathing was pure as rainwater. The name of it, in the language of the Pottawatomie who once lived there, meant “clarity” or “transparent”: Maxinkuckee. Lake Maxinkuckee was “an enchanted body of water to me,” said Kurt Jr., remembering it many years later, “my Aegean Sea, perfect in every dimension.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn81",
      "id": "ch1-fn81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The basin of Lake Maxinkuckee was gouged into the sandy soil by the scraping heel of a glacier and is constantly refreshed by spring water. Two and half miles wide and a mile and a half long, the lake has a thirteen-mile shoreline of rocky beach ringed by forests of oak, beech, and maple. The small town of Culver sits on its northeastern side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Vonneguts and their relatives—the Schnulls and the Glossbrenners, mainly—summered in five cedar-sided homes (“owned jointly and often acrimoniously” when it came to paying taxes) on the most desirable side of the lake, the sunny eastern shore. Another branch of the family owned Hollyhock Farm with a thirty-acre orchard of Jonathan, Grimes, and Wagener apple trees."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn82",
      "id": "ch1-fn82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" Taken as one holding, the property constituted a freshwater fiefdom owned by a German American family several generations deep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Vonneguts’ exodus to Lake Maxinkuckee started soon after Memorial Day by driving down Meridian Street until it became a flat, two-lane road, Route 31. The trip was straight north for ninety miles through the Indiana countryside. Stopping for lunch, they arrived at their cottage at 782 East Shore Drive by early afternoon. Then came the ceremony of taking down the winter shutters, raising the windows, and letting sunlight and fresh air ventilate the rooms for the first time in many months. Last, the boathouse would be unlocked, freeing the canoes and the leaky rowboat that Kurt Jr. had christened the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Beralikur")]), _vm._v("—a combination of “Bernard, Alice, Kurt.” That evening everyone would tuck into his or her first dinner at the lake, eating by the glow of a kerosene lamp."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn83",
      "id": "ch1-fn83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Evenings were spent reading—Tennyson, Poe, Dickens, Hawthorne, Stevenson, Emerson, and James Whitcomb Riley were favorites—or playing Old Maid, Pinochle, or Parcheesi. At sunset, Culver Military Academy fired a cannon. Hearing that martial sound, Kurt Jr. hoped never “to be yelled at and have to wear a uniform.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn84",
      "id": "ch1-fn84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" Before bedtime, he would run down the pier his father had built and fling himself off the end, clutching a bar of soap for his bath.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("O BE")]), _vm._v(" German was celebrated at the lake. The older folks tended to converse in German to stay in practice."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn85",
      "id": "ch1-fn85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" Kurt Jr. resented it when his parents shut him out of the conversation that way."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn86",
      "id": "ch1-fn86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" His father, who was in better spirits on vacation, sometimes cupped his hands to his mouth and jokingly called out, “Epta-mayan-hoy?,” which sounds Native American but is ersatz German for “Do abbots mow hay?” The proper response was for one of the children, sometimes as many as half a dozen during a single summer, to shout back, “Ya, epta-mayan-hoy!” (“Yes, abbots mow hay!”)"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn87",
      "id": "ch1-fn87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later in life Kurt Jr. complained about how little he really knew about German culture. He likened his situation to the title of an opera by Richard Strauss. “"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Die Frau ohne Schatten")]), _vm._v("—the woman without a shadow, I was a kid without a shadow, an ethnic shadow. My parents could have taught me German but they didn’t. I had no ethnic awareness whatsoever.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn88",
      "id": "ch1-fn88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" He blamed his parents for this—another refrain of “Nobody taught me anything.” But he also blamed anti-German sentiment during the First World War, which “so shamed and dismayed my parents that they resolved to raise me without acquainting me with the language or the literature or the music or the oral family histories which my ancestors loved. They volunteered to make me ignorant and rootless as proof of their patriotism.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn89",
      "id": "ch1-fn89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("During World War I, fear of the Hun (and envy over German Americans’ prominence in business) led the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Indianapolis Star")]), _vm._v(" to print the names and addresses of eight hundred German immigrants who were not naturalized. Someone threw yellow paint on Das Deutsche Haus, the city’s German cultural center, which the members voted to rename the Athenaeum."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn90",
      "id": "ch1-fn90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" One morning, Kurt Sr. reached into his mailbox to find an anonymous note: “Stop teaching your kids that Dutch”—slang for German."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn91",
      "id": "ch1-fn91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" Ironically, of course, neither Alice nor Bernard (Kurt Jr. wasn’t born yet) had been taught to speak German. Kurt Sr.’s mother, Nannette, also suffered a scare. The chauffeur she hired, a well-educated gentleman, “turned out to be spying on us,” said Kurt Sr.’s sister, Irma. “He was trying to find out whether we were disloyal or not.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn92",
      "id": "ch1-fn92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" Putting the lie to this kind of prejudice was the fact that eight Vonnegut men registered for the draft, including Kurt Sr."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn93",
      "id": "ch1-fn93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were many reasons for German Americans in Indianapolis to feel affronted, angry, or defensive. But their behavior doesn’t square with Kurt Jr.’s belief that his parents were ashamed. Regular junkets aboard ship to Germany by the family continued at an energetic pace throughout the 1920s and early 1930s. In fact, Kurt Sr. sailed to Hamburg aboard the brand-new luxury liner the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Deutschland")]), _vm._v(" two months after the stock market crash."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn94",
      "id": "ch1-fn94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" The Vonneguts, the Liebers, and their relatives were proud of their heritage, but they thought of it in lyrical and cultural, not political, terms. Indianapolis was replete with the efforts of German Americans to improve the city: the German-English School Society, the Musikverein, the German American Veterans Society, the German Literary Club, the Freethinkers Society, and the soaring Indiana Soldiers’ and Sailors’ Monument, designed by a Berlin architect. Later, during World War II, there was a saying in the Vonnegut home that the only thing wrong with the Germans was that they were in Germany."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn95",
      "id": "ch1-fn95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Moreover, the intellectual tradition of German rationalism and liberalism ensured that families like the Vonneguts refused to be cowed by nativists and bigots. Said Kurt Jr. himself many years later, “To them this country did have religious documents: the Declaration of Independence and the Bill of Rights.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn96",
      "id": "ch1-fn96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" They endured the slings and arrows of zealots and moved on with their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In any case, the greatest benefit from Kurt Jr.’s life at the lake wasn’t cultural. It was the abundant affection he received from belonging to the saga of the Vonnegut clan at Lake Maxinkuckee. Just his being there—swimming, canoeing, lighting firecrackers on the Fourth of July—added to family lore that spanned three generations. The contentment he felt erased his feelings of loneliness and anxiety at home. He later came to believe that in a perfect world every child who is at odds with his parents—whether the adults were cold or too demanding—should have an understanding relative to go to."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn97",
      "id": "ch1-fn97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" That person would serve as a safety net in times of trouble or just lend a sympathetic ear. And in his family, there was such a relative—someone who was “responsive and amusing and generous with me … my ideal grown-up friend”—his uncle Alex Vonnegut."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn98",
      "id": "ch1-fn98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Uncle Alex was Kurt Sr.’s gregarious younger brother, Harvard educated, and a broker for the Provident Mutual Life Insurance Company. His favorite three words, he said, were "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("enclosed find check")]), _vm._v("."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn99",
      "id": "ch1-fn99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" Later in life he confessed to feeling disappointed that he hadn’t lived up to his expectations."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn100",
      "id": "ch1-fn100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" Selling insurance was too easy, and he was bored. Still, “he was bubbling with good humor,” said Kurt Jr.’s cousin Walt Vonnegut, and he loved children."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn101",
      "id": "ch1-fn101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" Alex once proclaimed humorously to a friend in a letter, “I am in the Prime of Senility.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn102",
      "id": "ch1-fn102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All of the nieces and nephews would claim him at Lake Maxinkuckee, pulling him by the hand out onto the porch of one of the cottages where they could fuss over him. They begged for an Edgar Allan Poe story or requested his most popular trick, making a cat’s cradle out of string, which was likely the inspiration for the title of one of Kurt Jr.’s novels years later."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn103",
      "id": "ch1-fn103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" He had been married since 1915, but he and his wife, Raye, had no children and never would. The reason—at least the one Alex gave to close relatives—was that he had contracted a venereal disease while making the Grand Tour of Europe after college and was incapable of fathering a child. Having missed this opportunity, he energetically acted the surrogate parent to his many nieces and nephews.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No doubt because Alex was partial to children, he put his finger on something troubling his nephew Kurt Jr. No one was listening to him. “When Kay was a child,” Alex said later, calling him by his family nickname, “he complained about not being able to talk and that he was always being interrupted.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn104",
      "id": "ch1-fn104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE TROUBLE")]), _vm._v(" was that he couldn’t seem to say anything important enough to get the attention he craved at home. “My sister was five years older than I was, my brother was nine years older, and at the dinner table I was the lowest ranking thing there. I could not be interesting to these vivid grownups.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn105",
      "id": "ch1-fn105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" The give-and-take of conversation swirled around him, usually at the center of which was Bernard. “My brother was just full of baloney about wonderful things that were happening to him.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn106",
      "id": "ch1-fn106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then, as he entered his teenage years, he stumbled on how to turn everyone’s head in his direction. As he recalled it, the strategy was simple: “The only way the youngest kid, by far the youngest kid, can hold attention is by being surprising.” After everyone else at the table volunteered, “Well, I had a pretty nice day today,” he would add dramatically, “Oh, I didn’t, not at all.” The clatter of silverware stopped, and his siblings and parents waited to hear what had happened."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn107",
      "id": "ch1-fn107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At first, he was guilty of anticlimax, and his remarks failed to entertain and were generally met with a nod. He got the hook, so to speak, and the conversation moved on. But over time his stories and jokes became bolder, more imaginative, and better told, causing his brother and sister to stifle their outbursts of laughter."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn108",
      "id": "ch1-fn108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Learning how to amuse was a skill, he realized. And for being tutored in the art of creating situations, practicing timing, and delivering punch lines, the perfect tutor was the radio. One of his favorite programs was "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Vic and Sade")]), _vm._v(", a couple in Bloomington, Illinois, with an adopted son, Rush."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn109",
      "id": "ch1-fn109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" Each episode took an ordinary event—a broken washing machine, an early morning errand—and spun it out with extremely droll dialogue, without a laugh track or live audience, as if the listener were eavesdropping on a family who didn’t know they were funny. It was only fifteen minutes long. The listener had to be engaged, entertained, and satisfied in that brief space of time. Listening critically to the big radio in his parents’ living room, he received his first fundamental lessons in writing. “It was beautifully timed and extremely clever. That was the Muzak of my life.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn110",
      "id": "ch1-fn110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And learning to be funny accomplished something he never thought possible: it changed the balance of power in his family. After he demonstrated to Alice that he could be a real card, delivering gags just like comedians, she moved closer to him. By comparison, Bernard, down in his basement laboratory or in his advanced classes, might be able to do wonders with electricity and chemicals and so on. But upstairs in the dining and living rooms, his brother was strengthening his alliance with their sister by becoming her partner in funny business. They became a duo performing favorite bits from Abbott and Costello, Burns and Allen, or Laurel and Hardy."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn111",
      "id": "ch1-fn111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sweetness of this victory absorbed him all his life. Later, he often created characters in groups of three in his novels, two men and one woman."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn112",
      "id": "ch1-fn112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" The ability to control humor put him in control of “the family drama here: my sister, my brother, and myself.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn113",
      "id": "ch1-fn113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("W"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ITH A")]), _vm._v(" new weapon in his quiver, Kurt Jr. sallied forth to practice it in adolescence. Alice, eighteen, was about to leave home for a few semesters at art school, and Bernard had followed in his father’s footsteps to the Massachusetts Institute of Technology. Where Kurt Jr. would attend high school, however, was dictated again by his parents’ diminishing finances. Unable to afford the kind of private education they had provided for Alice and Bernard, they enrolled their youngest at the new powerhouse of public secondary education in the city, Shortridge High School.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shortridge, at 3401 North Meridian Street, looks almost exactly as it did when Vonnegut enrolled as a freshman in 1936. The original building, where his parents attended high school, had closed in 1928, and the new Shortridge building was already bulging with more than the twenty-five hundred students it was intended for. The reason for the overcrowding was that jobless graduates were allowed to reenroll. “Hardly any of us had any money,” said a classmate of Vonnegut’s during the Great Depression. “But on thinking it over I decided that we "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("were")]), _vm._v(" rich—we had the finest school filled with the best teachers—and indeed we did have everything.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn114",
      "id": "ch1-fn114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shortridge has an air of monumentality: a three-story, brick rectangle building with a Corinthian facade featuring a front entrance with six columns. Panels above the doors illustrate scenes of a classical education: art, music, literature, commerce, philosophy, and ethics. The interior rooms and hallways are finished in golden oak, ceramic tile, and plaster. Kurt Jr. couldn’t contain his excitement about this new chapter beginning in his life: “If your parents could get you there, you got to go there. God, I remember an ancient history course there, it was just a knockout. A real chemist headed the chemistry department, Frank Wade, who taught and worked as a chemist. So my brother, going to the Park School while maintaining his ‘upper class status,’ bicycled to Shortridge to study chemistry with Frank Wade.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn115",
      "id": "ch1-fn115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To choose his courses, he relied on what friends said about the best teachers."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn116",
      "id": "ch1-fn116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" But here Bernard stepped in, supplanting his parents’ authority about his brother’s choices. The first disagreement was over foreign language. Kurt Jr. wasn’t interested in German, which Bernard recommended, despite his complaint later that he had been cut off from his heritage. He begged to be allowed to take Latin instead, so he could join the school’s largest club, the Roman State. (Incredibly, twelve hundred students belonged—half the school.) “But I wasn’t to study Latin, I was to study German, a technical language,” because Bernard insisted it was more useful."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn117",
      "id": "ch1-fn117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" Two years of German, his parents decided, would be followed by two years of French because it was part of a liberal education. When it came to freshman science, he wanted to enroll in zoology because he liked animals, but Bernard pointed out “it wasn’t physical science enough.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn118",
      "id": "ch1-fn118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" So zoology was out and chemistry was in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nevertheless, he did well his freshman year: all As and Bs in core courses such as English, algebra, and chemistry, which, considering that he later insisted he had no interest or talent for science, is worth noting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The summer of 1937 he worked at the Vonnegut Hardware on East Washington Street for his great-uncle Franklin Vonnegut. His job was running the freight elevator up and down between six floors, eight hours a day, a Sisyphean task that gave him a glimpse of life in hell, he later said."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn119",
      "id": "ch1-fn119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Franklin made a mistake, however. As the owner of the business, he assigned his nephew number two on the time clock, right under him, which was taken by the other workers as tiresome evidence of the unfairness of nepotism. Kurt was embarrassed."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn120",
      "id": "ch1-fn120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" Many of the men employed by Vonnegut Hardware were making the same salary he was—fourteen dollars a week. It was his first real-life lesson in social and economic disparity, illustrating what he had read in a book recently given to him by Uncle Alex: Thorstein Veblen’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Theory of the Leisure Class")]), _vm._v(". He reveled in its attacks on conspicuous consumption, “since it made low comedy of the empty graces and aggressively useless possessions which my parents, and especially my mother, meant to regain some day.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn121",
      "id": "ch1-fn121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" With the excitement of a youngster who has at last caught his parents red-handed, he realized he was being raised to become bourgeois.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OPHOMORE YEAR,")]), _vm._v(" Kurt took up smoking—smart-looking Pall Mall cigarettes in the red package with a coat of arms and the Latin motto "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("In hoc signo vinces")]), _vm._v(" (By this sign shall you conquer). He determined too that he would have a girlfriend. Girls liked him because he was polite and funny, and, for his part, he “fell in love with girls.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn122",
      "id": "ch1-fn122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" In fact, he had his eye on one in particular, Mary Jo Albright.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Christmas morning, he wrapped a present and left early for the short walk to her house on North Washington Street. Inside the gift box, he had a teddy bear. He hoped it would strike the right note between friendship and thoughtfulness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mary Jo’s father answered the door and welcomed him in, calling for his daughter to come down and meet the young gentleman who had just arrived. From her expression, Kurt could tell she was surprised to see him. They sat on the couch and he presented his gift. Opening the wrapping, she fussed over the teddy bear and thanked him. But after a few moments, she explained they couldn’t talk long—she was expecting her date, Bill Shirley. They had made plans to go skating together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Kurt made the best of things and started making his exit, thanking her father and wishing them a Merry Christmas. It had been a sincere, if inelegant, expedition of the heart."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn123",
      "id": "ch1-fn123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In his bedroom he would stand at his window at night and watch a teenage girl, Nina Brown, undress in her lighted window through the backyard trees."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn124",
      "id": "ch1-fn124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" In his home life, the relationship between his parents illustrated almost nothing about tenderness and sexuality, and echoes of it can later be heard in his novels. His stories are rife with loneliness, bad relations between parents and children, unsuccessful attempts at romance, and a kind of chilliness of the heart that prevents the protagonist from feeling emotion."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn125",
      "id": "ch1-fn125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" In addition, the Vonneguts’ twin belief systems going back several generations—unitarianism and freethinking—gave no guidance about sex and love.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His father tried to provide a passion that would unite them as men. He was an expert collector of guns, all kinds, but especially antique pistols and revolvers."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn126",
      "id": "ch1-fn126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" The rarest he owned was a one-hundred-year-old single-shot Belgian target pistol with blued barrel and carved stock inlaid with gold. It might have been used in a duel, when men would die rather than accept dishonor. He wanted his son to appreciate the whorls on a particular gun’s etched barrel, the teardrop loop of its gold trigger guard, its dark walnut grip, fashioned when Napoleon was emperor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The rites of initiation succeeded. Kurt Jr.’s cousin Walt paid him a visit and was hugely impressed by what he saw in Kurt Jr.’s bedroom. “Saw K’s two automatic pistols,” he noted in his diary. “He has 11 rifles & shotguns not including the one I borrowed, and 4 pistols. Of course, most of the guns really belong to Uncle Kurt, I believe, but K has them in his room.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn127",
      "id": "ch1-fn127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was a kind of armory, a masculine citadel.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("URING THE")]), _vm._v(" summer between his sophomore and junior years, Kurt worked at Vonnegut Hardware again, this time on the sales floor, discovering that the customers stole regularly, and that working where there were no windows was not for him."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn128",
      "id": "ch1-fn128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" After ringing up a sale, he always added a complimentary gift to the customer’s purchase: a twelve-inch wooden ruler that doubled as an “Indiana Legal Length Fish Gauge.” Printed at the seven-inch mark was the prescient word "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Trout.")]), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn129",
      "id": "ch1-fn129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" But he dreaded the fate of many male Vonneguts, which was to end up with a career in the venerable hardware store or, as he characterized it to a friend, “working in the nuts and bolts department.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn130",
      "id": "ch1-fn130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Finally, the big house on North Illinois Street sold in 1939, and his parents used the money to buy property in the Williams Creek subdivision of Indianapolis. In the meantime, until they could build a smaller house, they lived catch-as-catch-can, badgered by money problems and general unhappiness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Edith took a fiction-writing course at the YWCA in the hope of selling short stories to women’s magazines. She imagined that once her stories caught on, the family could vacation on Cape Cod again while she continued to write. Hearing her talk about editors, guidelines, and submissions, her son became intrigued with the idea of being an author. “It was my mother more than my father who stirred my interest in literature, except that whatever talent I have was his—his letters were exquisite.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn131",
      "id": "ch1-fn131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" But her stories were hopelessly out of date in tone and subject matter. They were country clubby and literary-sounding when readers wanted a bit of raciness and a few burning kisses to escape the dreariness of the Depression. “She never sold anything. I was aware of that.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn132",
      "id": "ch1-fn132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Meanwhile, his father, who had once spun around an eleven-thousand-ton building without anyone inside feeling a shudder, fussed over an invention that he hoped would bring in a dependable stream of money. It was a device for cleaning out pipe stems, a kind of piston in the stem. But it would require changing the design on every pipe made, and it would work only on straight stems. He took out a patent on it."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn133",
      "id": "ch1-fn133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" Predictably, no one expressed any interest.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UNIOR YEAR")]), _vm._v(" in high school, Kurt Jr. took his first drink, a surreptitious one. One autumn afternoon, upon arriving home after school, “[I] discovered mother decorating the house, having a jug of sherry. There was a very pretty light coming through it. I took a slug from that and, man, it really felt nice.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn134",
      "id": "ch1-fn134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" Alcohol and cigarettes, two means of self-medicating his high and low mood swings, became addictions he would never be able to shake.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For another reason, a more salutary one, his junior year was important: Vonnegut began appearing in print regularly in the Shortridge High School "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Echo")]), _vm._v(". About sixty students produced the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Echo")]), _vm._v(", although publishing it with an ever-rotating staff—a different one for each day of the week—was a scramble."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn135",
      "id": "ch1-fn135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" Every weekday morning, a new edition of the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Echo")]), _vm._v(" appeared, providing the student body and faculty with the latest news about school activities, events, and sports.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first article carrying Vonnegut’s byline, “This Business of Whistle Purchasing,” a lighthearted criticism of a school fund-raiser, was submitted at the urging of his sophomore English teacher. Then beginning in his junior year, he contributed a piece to the newspaper practically every week, sometimes as many as four—news, commentary, sports—which he sometimes signed, in place of his real name, “Ferdinand” or “Koort” or, his kookiest moniker, “Koort Snarfield Vawnyagoot II.” Silly pen names aside, his work for the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Echo")]), _vm._v(" launched him as a writer. His happiness from being in print stemmed from the realization that he had a gift when it came to putting words on paper. “Each person has something he can do easily and can’t imagine why everybody else is having so much trouble doing it. In my case it was writing.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn136",
      "id": "ch1-fn136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" Looking back, he attributed basic elements of his fictional style to having an instant audience in high school: “I was writing for my peers and not for teachers, it was very important to me that they understand what I was saying.” Also the journalistic style of short, punchy sentences, active verbs, and strong structure appealed to him. “Because I believed in the merits of this type of prose, I was quite ‘teachable’ and so I worked hard to achieve as pure a style as I could.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn137",
      "id": "ch1-fn137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An added benefit was that his articles were continual advertisements for himself on the social scene. Suddenly, the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Echo")]), _vm._v("’s gossip columnists began taking note of this new big-man-on-campus. “Tip to Kurt Vonnegut. Please look at the person to whom you are going to speak. It is rather disturbing to have you look the other way and then say ‘hello.’ Shortridge girls.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn138",
      "id": "ch1-fn138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" Another gossip columnist touted him as the best candidate to lead the junior talent show. “Plug for Kurt Vonnegut, who is planning on running for Junior Vaudeville chairman. Don’t you think he would be a keen one, though? For if he applies a touch of that subtle Vonnegut wit to the Vaudeville, it should be really whizz-bang!”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn139",
      "id": "ch1-fn139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" He won the election.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He became known as something of a character. Humor and rudimentary charm were becoming his trademarks. At a dancing class, run by a Mrs. Gates, where Indianapolis’s young ladies and gentlemen learned the waltz and foxtrot, he arrived one evening wearing the required blue serge suit and white gloves. As he glided over the floor, he quietly let a trail of marbles dribble through a hole in his trouser pocket, hoping couples would take indecorous pratfalls. “Everybody (except Mrs. Gates) loved him,” said his partner that night."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn140",
      "id": "ch1-fn140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By midyear he was a member of the Student Council, the Junior Social Committee, the Press Club, the Drama League, the Fiction Club, and the Junior Pin and Ring Committee. The "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Echo")]), _vm._v(" noted his “intriguing personality,” said he was an upperclassman “who is worshipped by freshmen femmes; thought of as ‘wonderful’ by Sally Evans, and ‘intriguing’ by Baba Kiger—Kurt Vonnegut remains oblivious to all. Universal opinion, Kurt—we need more people like you.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn141",
      "id": "ch1-fn141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was Kurt Vonnegut Jr.—writer, wit, and mischief maker.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("H"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("IS SENIOR")]), _vm._v(" year, he turned his attention to life after high school, but in his mind, at least, the way seemed clear. His work on the school paper had led him to read H. L. Mencken, the acerbic critic of politics and American life: “I knew something about his life—that he had had a very exciting time as a newspaper reporter—and I guess later as a city editor. I read a couple of his autobiographical works, and as a result of this I wanted to be a newspaperman.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn142",
      "id": "ch1-fn142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" On his own, he found his way to the editorial offices of the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Indianapolis Star")]), _vm._v(" and, in the course of asking some advice about how to get into journalism, was offered a job by the managing editor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For a young man, it was a remarkable coup. And it would have been the first step toward independence, had Bernard not stepped in. His brother was by then in graduate school in physics at MIT. While Kurt Sr.’s star had sunk lower and lower as an architect and amateur artist until he was “completely demoralized,” Bernard had proved by example that he had been right all along: the “arts were ornamental.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn143",
      "id": "ch1-fn143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" In the new world, the laurels would go to scientists, technicians, the practitioners of the practical arts—not daubers in art, like Alice, who had failed to complete art school, or, by extension, scribblers like the kind Kurt Jr. wanted to be. No one in the family had made good by chasing after the Muses. Humankind would be grateful to those who understood the natural and physical sciences.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Kurt Sr. could no longer speak with authority about what was worth spending your life on. His confidence had fled. The sum of his years spent drawing designs that he hoped would leave his imprint on Indianapolis, and his participation in societies devoted to discussing art, had come to nothing. His only advice to his namesake was “Be anything but an architect.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn144",
      "id": "ch1-fn144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was decided that Kurt Jr. would attend Cornell, which his great-uncle Franklin Vonnegut, as well as a cousin, Richard C. Vonnegut, had attended. His major would be chemistry or perhaps biochemistry. But there must have been bad blood about it. When Kurt graduated from Shortridge High School in June 1940, neither of his parents was in the audience. He never forgave them for the snub. “Really low class.” Later, they apologized."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn145",
      "id": "ch1-fn145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The summer between high school and college, Kurt and Bernard went hiking in New Hampshire’s White Mountains. But in the back of his mind, Kurt was worried about his scores on the college boards and suggested they call Cornell to “just make sure everything’s okay.” To his humiliation, his admission as a chemistry major to Cornell was uncertain because, although he had received an A+ in high school physics, his math scores on the boards were low. Bernard drove him to Harvard, where he was accepted provisionally.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the meantime, their father persuaded the principal of Shortridge to contact the admissions office at Cornell and vouch for his son. “And so yeah, I got admitted to Harvard, on a trial basis, or whatever. And to MIT, the same thing, but Bernie said I better go to Cornell, which was his idea of me, sort of third rate.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn146",
      "id": "ch1-fn146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Bernard had vetoed his dreams, which were to become a writer, and throughout his life he put the blame on his brother for interfering. “Bernie really fucked up my life. If it hadn’t have been for him, all the shit that was about to happen to me wouldn’t have happened. I enrolled in the sciences at Cornell only as a sop to him, no other reason. Later, I was in a real mess.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1_fn147",
      "id": "ch1-fn147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f604df2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 72
// module chunks = 0